export default __webpack_public_path__ + "static/media/earn.bf83ec19.png";